import { useForm } from '@inertiajs/react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function CreateStageForm({ eventSlug }: { eventSlug: string }) {
  const [open, setOpen] = useState(false);
  const form = useForm({ name: '', slug: '' });
  const { data, setData, processing } = form;
  const errors = form.errors as unknown as Record<string, string | undefined>;
  const error = errors.base ?? errors.name ?? errors.slug ?? null;

  const reset = () => {
    form.setData({ name: '', slug: '' });
    form.clearErrors();
  };

  const submit = () =>
    form.post(`/admin/${eventSlug}/stages`, {
      preserveScroll: true,
      preserveState: true,
      onSuccess: () => {
        reset();
        setOpen(false);
      },
    });

  return (
    <>
      <Button className="rounded-none" onClick={() => setOpen(true)}>
        New stage
      </Button>
      <Dialog
        open={open}
        onOpenChange={(v) => {
          setOpen(v);
          if (!v) reset();
        }}
      >
        <DialogContent className="rounded-none">
          <DialogHeader>
            <DialogTitle>Create stage</DialogTitle>
            <DialogDescription>
              A stage groups projects in a presentation order. Each stage can
              have one project marked as currently presenting.
            </DialogDescription>
          </DialogHeader>

          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-1.5">
              <Label>Name</Label>
              <Input
                className="rounded-none"
                value={data.name}
                onChange={(e) => setData('name', e.target.value)}
                disabled={processing}
                placeholder="Main stage"
                autoFocus
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label>Slug</Label>
              <Input
                className="rounded-none"
                value={data.slug}
                onChange={(e) =>
                  setData(
                    'slug',
                    e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '-'),
                  )
                }
                disabled={processing}
                placeholder="main"
              />
            </div>
          </div>

          {error && (
            <p className="bg-destructive/10 p-2 text-destructive text-sm">
              {error}
            </p>
          )}

          <div className="mt-2 flex justify-end gap-2">
            <Button
              className="rounded-none"
              variant="outline"
              onClick={() => setOpen(false)}
              disabled={processing}
            >
              Cancel
            </Button>
            <Button
              className="rounded-none"
              onClick={submit}
              disabled={processing || !data.name || !data.slug}
            >
              {processing ? 'Creating…' : 'Create stage'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
